function getLocation (cb) {
    if (!navigator.geolocation) {
        return 'error'
      } else {
        navigator.geolocation.getCurrentPosition((pos) => {
          var latt = pos.coords.latitude
          var lonn = pos.coords.longitude
          console.log('in service',latt,lonn)
          cb({
            lat: latt,
            lon: lonn
          })
          // console.log(lat,lon)
        });
      }
}
export default getLocation;